<style lang="scss" scoped>
@import "./start-page.scss";
</style>
<template>
  <div class="start-page">
    <span class="hidden-sm-and-down"><br /><br /></span>
    <img
      src="@static/images/site-onboarding/img_start_page.png"
      class="main-img"
    />
    <span class="main-text">{{ randomMainText }}</span>
    <img class="loader" :src="loadingImg" alt="loading" />
    <span class="hidden-sm-and-down"><br /><br /></span>
  </div>
</template>

<script>
export default {
  name: "StartPage",
  computed: {
    loadingImg() {
      return require(`@static/images/site-onboarding/onboarding-loading.gif`);
    },
    randomMainText() {
      return this.listTexts[Math.floor(Math.random() * this.listTexts.length)];
    },
  },
  data() {
    return {
      nextPageTimeout: null,
      listTexts: [],
    };
  },
  mounted() {
    this.listTexts = this.$t("$onboarding.start_page_list_text");
  },
};
</script>
